<template>
  <div class="max-w-md px-2 mx-auto mt-5">
    <div class="mb-2 text-xl font-medium text-center">
      Call Tracking Setup
    </div>
    <div class="p-4 bg-white border rounded-md shadow">
      <form @submit.prevent="create">
        <div class="mb-3">
          <label for="cid" class="block">CID Number</label>
          <input type="text" inputmode="numeric" class="w-full p-2 border rounded focus:outline-none focus:shadow-outline" placeholder="12345" title="Number without space" v-model="cid">
        </div>
        <div>
          <label for="telephone" class="block">Telephone Number</label>
          <input type="text" inputmode="numeric" class="w-full p-2 border rounded focus:outline-none focus:shadow-outline" placeholder="66788876" title="Number without space" v-model="phoneNumber">
        </div>
        <CollapseTransition>
          <div class="mt-3" v-if="isValidNumber && validCid">
            <span>URL</span>
            <div class="flex flex-wrap justify-between p-2 bg-gray-200 rounded">
              <div class="flex-1 overflow-x-hidden truncate">{{ url }}</div>
              <button @click.prevent class="copy focus:outline-none" :data-clipboard-text="url" data-tippy-content="Copy">
                <svg class="w-5 h-5 text-gray-500 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M7 4V2h10v2h3.007c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.994.994 0 0 1 3 21.007V4.993C3 4.445 3.445 4 3.993 4H7zm0 2H5v14h14V6h-2v2H7V6zm2-2v2h6V4H9z"/></svg>
              </button>
            </div>
            <button class="w-full p-2 mt-3 text-white transition duration-100 ease-in-out bg-indigo-500 rounded hover:bg-indigo-600 focus:outline-none focus:shadow-outline">View Instruction</button>
          </div>
        </CollapseTransition>
      </form>
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import { CollapseTransition } from 'vue2-transitions'
import _ from 'lodash'
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();


export default {
  name: 'Home',
  components: {
    CollapseTransition
  },
  data() {
    return {
      cid: '',
      phoneNumber: '',
      clipboard: 'Copy',
      isValidNumber: '',
      validCid: ''
    }
  },
  methods: {
    create() {
      this.$router.push({ name: 'Guide', params: { cid: this.cid, telephone: this.phoneNumber } })
    }
  },
  watch: {
    phoneNumber(newValue) {
      try {
        const number = phoneUtil.parseAndKeepRawInput(newValue, 'SG')
        this.isValidNumber = phoneUtil.isValidNumber(number)
      } catch (error) {
        this.isValidNumber = false
      }
    },
    cid(newValue) {
      try {
        this.validCid = newValue.match(/^[0-9]*$/gm) && !_.isEmpty(newValue) ? true : false
      } catch (error) {
        this.validCid = false
      }
    }
  },
  computed: {
    url() {
      return window.location.href + 'guide/' + this.cid + '/' + this.phoneNumber
    }
  },
  mounted() {
    new ClipboardJS('.copy')
  }
}
</script>
